import React from 'react';
import './about.css';
import renderHTML from 'react-render-html';
const AboutPara = (props) => {
    return (
        <p className={`paraRegular ${props.class}`} style={{ ...props.style }}>{renderHTML(props.title)}</p>
    )
}
export default AboutPara;